import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

interface VideoPlayerProps {
  src: string;
  pageId: number;
}

const VideoPlayer = ({ src, pageId }: VideoPlayerProps) => {
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      if (currentPage === pageId) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  return (
    <div style={{ position: "absolute", zIndex: 100, right: "var(--width-80)", top: "var(--height-280)" }}>
      <video
        key={src}
        controls
        ref={videoRef}
        style={{ width: "var(--width-1080)" }}
        src={src}
        onError={(e) => console.error("Error loading video:", e)}
      />
    </div>
  );
};

export default VideoPlayer;
